import React from 'react';
import TableC from '../basicElement/TableC';

/**
 * 随机(入组)计划 各中心执行计划列表
 * 当 isGivenSecondLines 为 true 时使用：
 * investigationSiteId 有值且 >= -1 的行每月明细按 计划/实际 展示（计划或实际无值填充0）
 * 待配置中心（-2）、津石合计（-3）等行只展示计划
 */
class SiteRandomList extends React.Component {

    getColumns = () => {
        const { titleList = [], isShow } = this.props;
        const shouldFixed = titleList.length > 0;
        const columns = [{
            title: '序号',
            dataIndex: 'index',
            key: 'index',
            width: 60,
            fixed: 'left',
            render: (text, record) => {
                const { investigationSiteId } = record;
                return investigationSiteId < 0 ? '-' : text
            }
        }, {
            title: '中心编号',
            dataIndex: 'investigationSiteCode',
            key: 'investigationSiteCode',
            sorter: true,
            width: 110,
            fixed: 'left',
            render : (text, record) => {
                const { investigationSiteId } = record;
                if (investigationSiteId < 0) {
                    return {
                        children: text,
                        props: {
                            colSpan: 0,
                        },
                    };
                }
                return text
            }
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            sorter: true,
            width: 140,
            fixed: 'left',
            render : (text, record) => {
                const { investigationSiteId } = record;
                if (investigationSiteId < 0) {
                    return {
                        children: text,
                        props: {
                            colSpan: 2,
                        },
                    };
                }
                return text
            }
        }, {
            title: '总体计划',
            dataIndex: 'planAmount',
            key: 'planAmount',
            sorter: true,
            fixed: 'left',
            width: 120,
        },{
            title: '实际随机(入组)数',
            dataIndex: 'actualAmount',
            key: 'actualAmount',
            fixed: 'left',
            width: 110,
        }, {
            title: '每月计划合计',
            dataIndex: 'monthlyPlanTotalAmount',
            key: 'monthlyPlanTotalAmount',
            width: shouldFixed && 120,
            fixed: 'left',
        }];

        titleList.forEach(item => {
            const { year, month } = item;
            columns.push({
                title: `${year}.${month}`,
                dataIndex: `${year}.${month}`,
                key: `${year}.${month}`,
                width: 80,
                render: (text) => {
                    return text || '0';
                }
            });
        });

        const { curRole, investigationSiteName } = sessionStorage;
        const showOperator = curRole == 'PA' || curRole == 'PM' || (!investigationSiteName && curRole == 'CTA');
        if (showOperator && !isShow) {
            columns.push({
                title: '操作',
                key: 'operation',
                fixed: shouldFixed && 'right',
                width: 60,
                render: (text, record) => {
                    const { investigationSiteId } = record;
                    if (investigationSiteId > 0) {
                        return (
                            <a onClick={() => this.props.canEditByInvStatus(() => this.props.setSitePlan(investigationSiteId))}>{!investigationSiteName ? '设置' : '调整'}</a>
                        );
                    }
                }
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination, visitGroupingList = [], visitGroupingId } = this.props;
        const { current, pageSize } = pagination;
        const dataSource = data.map((item, index) => {
            const { investigationSite, monthlyPlanList, ...rest } = item;
            const params = {
                index: (current - 1) * pageSize + index + 1,
                ...rest,
                ...investigationSite,
            };
            if (monthlyPlanList && Array.isArray(monthlyPlanList)) {
                const { investigationSiteId } = params;
                monthlyPlanList.forEach(monthlyPlan => {
                    const { year, month, planAmount, actualAmount } = monthlyPlan;
                    const plan = planAmount == null ? 0 : planAmount;
                    //investigationSiteId 有值且 >= -1 的显示 计划/实际，计划或实际无值填充0；待配置中心（-2）、津石合计（-3）只显示计划
                    if (investigationSiteId != null && investigationSiteId >= -1) {
                        const actual = actualAmount == null ? 0 : actualAmount;
                        params[`${year}.${month}`] = `${plan}/${actual}`;
                    } else {
                        params[`${year}.${month}`] = plan;
                    }
                });
            }
            return params;
        });
        let newDataSource = [];
        if (visitGroupingId != (visitGroupingList[0] || {}).visitGroupingId) {
            newDataSource = dataSource.filter(el => el.investigationSiteName !== '待配置中心')
        } else {
            newDataSource = dataSource;
        }
        return newDataSource;
    }

    render() {
        const { loading, pagination, sortParams } = this.props;
        const { siteId } = sessionStorage;
        return (
            <div>
                <div style={{ marginBottom: 6 }}>
                    <span>每月明细显示规则：计划/实际</span>
                </div>
                <TableC
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    data={this.getDataSource()}
                    pagination={siteId == 0 ? pagination : false}
                    onChange={this.props.onChange}
                    rowKey="investigationSiteId"
                />
            </div>
        );
    }
}

export default SiteRandomList;



// WEBPACK FOOTER //
// ./src/components/plan/SiteRandomList.js